
import { Component, Prop, Vue } from 'vue-property-decorator'
import { TimeUtil } from '@/helpers/TimeUtil'
import { formatAmount } from '@/helpers/data'
import { clientsModule } from '@/store/modules/store-accessor'
import { openInstallationSideview } from '@/helpers/installationSideview'

@Component
export default class ClientsSideviewCreditTab extends Vue {
  @Prop({ required: true }) credit!: ClientCreditDto
  @Prop({ default: 0 }) availableCredit!: number
  @Prop({ default: () => [] }) payments!: Record<string, any>[]

  openingEntryId: number | null = null

  get installationByJob(): Record<string, string | number> {
    const map: Record<string, string | number> = {}
    this.payments.forEach((payment) => {
      if (payment.job_id && payment.installation_id) map[String(payment.job_id)] = payment.installation_id
    })
    return map
  }

  installationIdFor(entry: ClientCreditLedgerEntryDto & { installation_id?: string | number | null }) {
    if (!entry.job_id) return null
    return entry.installation_id || this.installationByJob[String(entry.job_id)] || null
  }

  async openJob(entry: ClientCreditLedgerEntryDto) {
    const installationId = this.installationIdFor(entry)
    if (!installationId || this.openingEntryId !== null) return
    this.openingEntryId = entry.id
    try {
      clientsModule.unsetCurrentClient()
      await openInstallationSideview({ installationId, tab: 'jobs', jobId: entry.job_id as number })
    } finally {
      this.openingEntryId = null
    }
  }

  headers = [
    { text: this.$t('date'), value: 'created_at' },
    { text: this.$t('type'), value: 'type' },
    { text: this.$t('amount'), value: 'amount', align: 'end' },
    { text: this.$t('job'), value: 'job_id', sortable: false, align: 'center' },
    { text: this.$t('payment_type'), value: 'payment_type_id' },
    { text: this.$t('created_by'), value: 'created_by_fullname' },
    { text: this.$t('notes'), value: 'notes' },
  ]

  formatDate(date: Date) { return TimeUtil.formatDateTime(date) }

  formatAmount(amount: number) { return formatAmount(amount) }

  isPositive(entry: ClientCreditLedgerEntryDto) {
    if (entry.type === 'ADJUSTMENT') return Number(entry.amount) >= 0;
    return entry.type === 'DEPOSIT';
  }

  typeIcon(entry: ClientCreditLedgerEntryDto) {
    switch (entry.type) {
      case 'DEPOSIT': return 'mdi-wallet-plus-outline';
      case 'APPLICATION': return 'mdi-briefcase-check-outline';
      case 'REFUND': return 'mdi-cash-refund';
      default: return 'mdi-scale-balance';
    }
  }
}
